export const meta_standard = 'Schillaci Guitars: Custom Guitars & Necks Made To Order.';
export const meta_guitars = meta_standard + ' Explore guitar models and find the perfect instrument for you.';
export const meta_about = meta_standard + ' Learn more about Darren Schillaci, the man behind the guitar.';
export const meta_contact = meta_standard + 'Contact Schillaci Guitars now for more information about order the perfect instrument for you,';
export const site_name = 'Schillaci Guitars';
export const site_url = 'schillaciguitars.com';
export const site_owner = 'Schillaci Guitars';

export const ga_tracking_code = 'UA-114677834-1';


// WEBPACK FOOTER //
// ./src/store/constants/meta_info.js